import { getChain } from '@sirius-cybernetics-42/product-config'

import { ALL_CHAIN_IDS } from '../chains'
import type { ChainId } from '../../sdk'

/** Endpoints públicos de lectura por cadena (desde product-config). Mono-build sigue usando `VITE_NETWORK_URL` para la cadena activa. */
export const DEFAULT_RPC_URLS = Object.fromEntries(
  ALL_CHAIN_IDS.map((chainId) => [chainId, getChain(chainId).defaultRpcUrl]),
) as Partial<Record<ChainId, string>>
